module.exports = __webpack_public_path__ + "img/icon-counter-share.d552d7e8.svg";